export const LoadingPlaceholderItem = () => (
  <div className="h-16 mb-2 bg-gray-200 rounded-md animate-pulse"></div>
);
